export default "__VITE_ASSET__CxcE0xxT__"